import styled from 'styled-components';
import { themeColor } from '../theme/colors';

export const Container = styled.div<{ $width: number }>`
  height: 16px;
  width: ${({ $width }) => `${$width}px`};
  background-color: ${themeColor('buttonBackground')};

  border-radius: 4px;

  overflow: hidden;
`;

export const Section = styled.div<{ $value: number; $parentWidth: number }>`
  height: 100%;
  width: ${({ $value }) => `${$value}%`};
  background: linear-gradient(
    90deg,
    #ad86ed 0%,
    #25fce7 ${({ $parentWidth }) => `${$parentWidth}px`}
  );
  transition: width 100ms;
`;
